import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from '../PageSections/PageSection';
import * as styles from './BehavioralDataCallout.module.scss';

/*
 Connectors Component
 This layout is a little unusual, and the best solution I came up with was to use a subgrid with some empty divs to create the "connector" elements after the first column.
 */
const Connectors = ({ content }) => (
  <div className={styles.connectors}>
    <span />
    {content.map((_, i) => (
      <div key={`connector-${i}`} />
    ))}
  </div>
);

export default function BehavioralDataCallout({ section }) {
  return (
    <PageSection className={styles.section} noPad={true} wide data-analytics-section={'behavioral-data-info'}>
      {section.mainImage && <ContentfulImage imageFragment={section.mainImage} lazy={true} className={styles.image} />}
      <h2>{section.title}</h2>
      {section.content[0].mainImage && (
        <ContentfulImage className={styles.mobileVisual} lazy={true} imageFragment={section.content[0].mainImage} />
      )}
      <div className={styles.columns} style={{ '--rows': section.content[0]?.content?.length + 1 }}>
        {section.content.map((column, i) => (
          <React.Fragment key={i}>
            <div
              className={styles.rows}
              data-analytics-component={'behavioral-data-info-row'}
              data-analytics-id={column.title}
            >
              <p className={styles.label}>{column.title}</p>
              {column.content.map((item, j) => (
                <p key={j} className={styles.item}>
                  {item.title}
                </p>
              ))}
            </div>
            {i === 0 && <Connectors content={column.content} />}
          </React.Fragment>
        ))}
      </div>
    </PageSection>
  );
}
